import type { ReactNode } from 'react'
import { cx } from './cx'

/**
 * The page title row. Every screen under `Layout` opens with this — see the
 * Page Layout Convention in CLAUDE.md for the surrounding shell.
 */
export default function PageHeader({
  title,
  description,
  actions,
  className,
}: {
  title: ReactNode
  description?: ReactNode
  actions?: ReactNode
  className?: string
}) {
  return (
    <div className={cx('flex items-start justify-between gap-3 flex-wrap mb-6', className)}>
      <div className="min-w-0">
        <h1 className="text-xl font-bold text-gray-900">{title}</h1>
        {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
  )
}
